/**
 * Coordinate utility functions for copying and formatting
 */

/**
 * Format coordinates as "lat, lon" for easy copying
 */
export function formatCoordinatesForCopy(latitude: number | undefined, longitude: number | undefined): string | null {
  if (latitude === undefined || longitude === undefined) {
    return null
  }

  return `${latitude.toFixed(5)}, ${longitude.toFixed(5)}`
}

/**
 * Copy coordinates to clipboard
 * Shows toast notification on success
 */
export async function copyCoordinatesToClipboard(
  latitude: number | undefined,
  longitude: number | undefined
): Promise<boolean> {
  const coordinates = formatCoordinatesForCopy(latitude, longitude)
  
  if (!coordinates) {

    return false
  }

  try {
    await navigator.clipboard.writeText(coordinates)

    return true
  } catch (error) {

    return false
  }
}

/**
 * Get Google Maps URL for coordinates
 */
export function getGoogleMapsUrl(latitude: number | undefined, longitude: number | undefined): string | null {
  if (latitude === undefined || longitude === undefined) {
    return null
  }

  return `https://www.google.com/maps?q=${latitude},${longitude}`
}

